export enum ModelStatus {
	Waiting,
	Accepted,
	ProfileNotSet,
	WaitingEmailVerification,
	Pending,

	Deleted = 30,
	Reported = 31,
	Blocked,
	BlockedDeleted,
	Restricted,
	Declined,

	Active = 35,
	Deactivate = 36,
	/** Money returned in full. Used by OfferPurchase; a refunded sale is no longer `Accepted`, so every access and seat check excludes it for free. */
	Refunded = 37,

	MonetizationPending = 50,
	PaymentMethodPending,
	SubscriptionPending,
	PaymentFailed,

	Unsubscribe = 60,

	IdentityVerificationPending = 70,

	SupabaseCustomDomainPending = 80,
	SupabaseCustomDomainVerificationPending = 81,
	SupabaseCustomDomainActivationPending = 82,

	OfferPublishPending = 90,

	Draft = 95,

	// --- Branded mobile app (CommunityMobileApp) ---
	// The overall record's lifecycle. Payment gates development: an intake sits at
	// MobileAppContractPending indefinitely, and staff only advance it past MobileAppPaid once
	// the money has cleared or `paidOffline` has been ticked.
	/** Intake submitted, not yet paid for. Renders the "Contract Pending" badge. */
	MobileAppContractPending = 100,
	/** Transient — payment cleared, staff have not yet picked the build up. */
	MobileAppPaid = 101,
	/** Being built by the Networked team. */
	MobileAppInDevelopment = 102,
	/** Handed to the stores; the per-store review timelines take over from here. */
	MobileAppSubmittedToStores = 103,
	MobileAppLive = 104,
	MobileAppCancelled = 105,

	// Per-store review state, held on CommunityMobileAppStore rather than the parent, because
	// Apple and Google diverge constantly and one column cannot express "accepted on one,
	// rejected on the other".
	MobileAppStoreSubmitted = 110,
	MobileAppStoreInReview = 111,
	MobileAppStorePendingRelease = 112,
	MobileAppStoreAccepted = 113,
	MobileAppStoreRejected = 114,
}
